import { env } from '@/config/env';
import { version as appVersion } from '../../package.json';

export const appInfo = {
  name: 'AarogyaFlow',
  version: env.VITE_APP_VERSION ?? appVersion
} as const;
